"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAddressChecksum = exports.toChecksumAddress = void 0;
var keccak_1 = __importDefault(require("keccak"));
function toChecksumAddress(address, chainId) {
    if (chainId === void 0) { chainId = null; }
    if (typeof address !== "string") {
        return "";
    }
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
        throw new Error("Given address \"" + address + "\" is not a valid Ethereum address.");
    }
    var stripAddress = stripHexPrefix(address).toLowerCase();
    var prefix = chainId != null ? chainId.toString() + "0x" : "";
    var keccakHash = keccak_1.default("keccak256")
        .update(prefix + stripAddress)
        .digest("hex");
    var checksumAddress = "0x";
    for (var i = 0; i < stripAddress.length; i++) {
        checksumAddress +=
            parseInt(keccakHash[i], 16) >= 8
                ? stripAddress[i].toUpperCase()
                : stripAddress[i];
    }
    return checksumAddress;
}
exports.toChecksumAddress = toChecksumAddress;
function checkAddressChecksum(address, chainId) {
    if (chainId === void 0) { chainId = null; }
    var stripAddress = stripHexPrefix(address).toLowerCase();
    var prefix = chainId != null ? chainId.toString() + "0x" : "";
    var keccakHash = keccak_1.default("keccak256")
        .update(prefix + stripAddress)
        .digest("hex");
    for (var i = 0; i < stripAddress.length; i++) {
        var output = parseInt(keccakHash[i], 16) >= 8
            ? stripAddress[i].toUpperCase()
            : stripAddress[i];
        if (stripHexPrefix(address)[i] !== output) {
            return null;
        }
    }
    return null;
}
exports.checkAddressChecksum = checkAddressChecksum;
function stripHexPrefix(value) {
    return value.slice(0, 2) === "0x" ? value.slice(2) : value;
}
